import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

type OverPercentageTooltipCellRendererProps = {
  value: string;
  title: string;
  description: string;
  showTooltip: (value: string) => boolean;
};

const OverPercentageTooltipCellRenderer = ({
  value,
  title,
  description,
  showTooltip,
}: OverPercentageTooltipCellRendererProps) => {
  if (showTooltip(value))
    return (
      <Box display="flex" alignItems="center" gap={0.5}>
        {value}
        <Tooltip
          title={
            <Box>
              <Typography fontWeight="bold" mb={1}>
                {title}
              </Typography>
              <Typography>{description}</Typography>
            </Box>
          }
        >
          <InfoOutlineIcon fontSize="small" />
        </Tooltip>
      </Box>
    );

  return value;
};

export default OverPercentageTooltipCellRenderer;
